import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const InventoryTypePages = {
  list: 'ListInventoryType',
  add: 'AddInventoryType',
  edit: 'EditInventoryType',
}

const title = t('pages.inventoryTypes')
const path = '/inventory-types'
const breadcrumb = [{ title, path }]

const inventoryTypeComponent = () =>
  import('@/pages/mainPageWithRoute/inventory-type/FormInventoryTypePage.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: InventoryTypePages.add,
  component: inventoryTypeComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: InventoryTypePages.edit,
  component: inventoryTypeComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: InventoryTypePages.list,
  component: () => import('@/pages/mainPageWithRoute/inventory-type/ListInventoryTypePage.vue'),
  meta: { title, requiresAuth: true },
}

export const InventoryTypes: RouteRecordRaw = {
  path,
  name: t('pages.inventoryTypes'),
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
